import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { Observable } from 'rxjs';
import { CategoryHOF, HofcategoryHallOfFame } from 'app/categories/category';

@Injectable({ providedIn: 'root' })
export class CategoryHOFService {
    catUrl = '';
    catHOFUrl = '';

    constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
        this.catUrl = baseUrl + 'api/CategoryHOF';
        this.catHOFUrl = baseUrl + 'api/HofcategoryHallOfFames';
    }

    //#region CategoryHOF
    getCategories(): Observable<CategoryHOF[]> {
        return this.http.get<CategoryHOF[]>(this.catUrl);
    }

    getCategoryById(id: number): Observable<CategoryHOF> {
        return this.http.get<CategoryHOF>(`${this.catUrl}/${id}`);
    }

    createCategory(params: CategoryHOF): Observable<CategoryHOF> {
        return this.http.post<any>(this.catUrl, params);
    }

    updateCategory(id: number, category: CategoryHOF): Observable<any> {
        return this.http.put(`${this.catUrl}/${id}`, category);
    }

    deleteCategory(id: number): Observable<CategoryHOF> {
        return this.http.delete<CategoryHOF>(`${this.catUrl}/${id}`);
    }
    //#endregion

    //#region HofcategoryHallOfFames
    getHofcategoryHallOfFames(): Observable<HofcategoryHallOfFame[]> {
        return this.http.get<HofcategoryHallOfFame[]>(this.catHOFUrl);
    }

    getHofcategoryHallOfFamesByHallOfFameId(id: number): Observable<HofcategoryHallOfFame[]> {
        return this.http.get<HofcategoryHallOfFame[]>(`${this.catHOFUrl}/ByHallOfFame`, { params: { hallOfFameId: id.toString() } });
    }

    getHofcategoryHallOfFameById(id: number): Observable<HofcategoryHallOfFame> {
        return this.http.get<HofcategoryHallOfFame>(`${this.catHOFUrl}/${id}`);
    }

    createHofcategoryHallOfFame(params: HofcategoryHallOfFame): Observable<HofcategoryHallOfFame> {
        return this.http.post<any>(this.catHOFUrl, params);
    }

    updateHofcategoryHallOfFame(id: number, categoryHOF: HofcategoryHallOfFame): Observable<any> {
        return this.http.put(`${this.catHOFUrl}/${id}`, categoryHOF);
    }

    deleteHofcategoryHallOfFame(id: number): Observable<HofcategoryHallOfFame> {
        return this.http.delete<HofcategoryHallOfFame>(`${this.catHOFUrl}/${id}`);
    }
    //#endregion
}
